"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const Settings_1 = __importDefault(require("configs/Settings"));
const mobx_react_1 = require("mobx-react");
const mapStateToProps = (stores) => ({
    userLocale: stores.UserStore.shortLocale
});
const HelpCenterLink = ({ articleLocales = ['pt', 'en', 'es'], articleSlug, userLocale, defaultLocale = 'en', ...rest }) => {
    let articleLocale = defaultLocale;
    if (articleLocales.includes(userLocale)) {
        articleLocale = userLocale;
    }
    return ((0, jsx_runtime_1.jsx)("a", { href: `${Settings_1.default.app.helpCenter}/${articleLocale}/article/${articleSlug}`, ...rest }));
};
exports.default = (0, mobx_react_1.inject)(mapStateToProps)(HelpCenterLink);
